// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-Cfg","importantInfo":"styles_importantInfo__1v3hb"};